// src/App.js
import React, { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import ReactGA from "react-ga4";
import Home from "./pages/Home";
import AboutUs from "./pages/AboutUs";
import { BlogList, BlogPost } from "./pages/Blog";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsAndConditions from "./pages/TermsAndConditions";
import FAQ from "./pages/FAQ";

import SmoothScroll from "./components/SmoothScroll";

const App = () => {
  const location = useLocation();
  const canonicalUrl = `https://comparedly.com${location.pathname === "/" ? "" : location.pathname}`;

  useEffect(() => {
    // Only initialize if not on localhost
    const isLocalhost = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
    if (!isLocalhost) {
      ReactGA.initialize("G-R4B5LGGFBG");
    }
  }, []);

  useEffect(() => {
    const isLocalhost = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
    if (!isLocalhost) {
      // Send pageview with a custom path
      ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });
    }
  }, [location]);

  return (
    <>
      <SmoothScroll />
      <Helmet>
        <link rel="canonical" href={canonicalUrl} />
      </Helmet>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/blog" element={<BlogList />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsAndConditions />} />
        <Route path="/faq" element={<FAQ />} />
      </Routes>
    </>
  );
};

export default App;
